/**
 * 1-ab-hero-cta.js
 * NIJ-254 — A/B test: homepage hero primary CTA button colour
 *
 * Control  (0): white button  — class psw-btn--white (default)
 * Variation (1): green button — class psw-btn--green
 *
 * Scope: homepage only, first psw-hero-section only.
 * Uses the GrowthBook Script Tag SDK (loaded in theme.liquid).
 */
(function () {
  'use strict';

  // Only run on the homepage
  if (window.location.pathname !== '/') return;

  function applyVariation(gb) {
    var result = gb.run({
      key: 'hero-cta-color',
      variations: ['control', 'green']
    });

    if (window.location.search.indexOf('debug_mode=true') !== -1) {
      // eslint-disable-next-line no-console
      console.log('[NIJ-254] hero-cta-color =', result.value, '| inExperiment =', result.inExperiment);
    }

    if (result.value !== 'green') return;

    // Target the primary CTA in the first hero section only
    var firstHero = document.querySelector('.psw-hero-section');
    if (!firstHero) return;

    var btn = firstHero.querySelector('.psw-btn--white');
    if (!btn) return;

    btn.classList.remove('psw-btn--white');
    btn.classList.add('psw-btn--green');
  }

  // growthbook_queue is flushed once the SDK initialises
  window.growthbook_queue = window.growthbook_queue || [];
  window.growthbook_queue.push(applyVariation);
})();
